export default "__VITE_ASSET__DzSsYsMx__";